module.exports = __webpack_public_path__ + "static/media/travis.a6dcc371.jpg";